export const initialState = () => {

  // var PLUGIN_BASEURL = process.env.PLUGIN_BASEURL;
  var PLUGIN_BASEURL = 'https://adctv-plugins.onrender.com';
  // var PLUGIN_BASEURL = "http://127.0.0.1:5500";

  return {
    readonly: false,
    currentUser: {
      id: null,
      firstName: "",
      lastName: null,
      email: "",
      roleName: "",
      userName: "",
      permissionNames: [],
    },
    currentTenant: null,
    childTenants: [],
    tags: {},
    components: [],
    templates: [],
    componentsCounter: {},
    fonts: [],
    loadedFonts: new Set(),
    currentFrame: 0,
    componentExitUrl: [],
    animationTimings: [{ duration: 0, delay: 0, easing: "linear" }],
    creatives: [],
    thumbnailUrl: "",
    activeCreativeId: null,
    activeCreativeName: "",
    activeCreativeVersion: 0,
    isSaved: true,
    isDraftSaved: true,
    saveCreativeStatus: "draft",
    draftPreviewId: null,
    publishedPreviewId: null,
    draftUpdatedDate: null,
    isPreview: false,
    templateCache: null,
    timedEvents: {},
  };
};

export const storageAdapter = new Proxy(localStorage, {
  get(target, name) {
    if (window?.store?.state?.readonly !== true) {
      if (typeof localStorage[name] === "function") {
        return localStorage[name].bind(localStorage);
      }

      return localStorage[name];
    } else {
      console.log(
        "%cCurrently in Readonly Mode, State is not persisted to localStorage",
        "color:red;background:yellow;"
      );
      if (typeof localStorage[name] === "function") {
        return () => { };
      }
    }
  },
});
